module.exports = __webpack_public_path__ + "img/login-v3.59db1303.svg";